import { receiptsCodeStates } from '@/febos/aduanas/receipts/views/utils/constants';

export default {
  SET_SELECTED_RECEIPT(state, payload) {
    state.selectedReceipt = payload;
  },
  SET_RECEIPTS_LIST(state, payload) {
    state.list = (payload.documentos || [])
      .map((receipt) => ({ ...receipt, selected: false }))
      .reduce((index, option) => ({
        ...index,
        [option.comprobanteId]: option
      }), {});
    state.pagination = {
      items: Number.parseInt(payload.totalElementos, 10),
      pages: Number.parseInt(payload.totalPaginas, 10)
    };
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  MARK_SELECTED_RECEIPTS(state, isSelected) {
    state.list = Object.values(state.list).map((element) => ({
      ...element,
      selected: isSelected
    }));
  },
  SET_DETAILS_RECEIPT(state, receipt) {
    state.detailsReceipt = state.list[receipt];
  },
  UPDATE_STATUS_RECEIPT(state, receipt) {
    state.list[receipt.receiptId].estado = receiptsCodeStates.facturado;
  },
  SET_DETAILS_SELECTED_RECEIPTS(state, selectedReceipts) {
    const selected = [];
    selectedReceipts.forEach((receipt) => {
      if (state.list[receipt.comprobanteId]) {
        selected.push(state.list[receipt.comprobanteId]);
      }
    });
    state.detailsSelectedReceipts = selected;
  }
};
